import { Link } from 'react-router-dom';
import styled from 'styled-components';
function OfferCard() {
  return (
        <Container className='container text-center'>

            <div className="text-container p-3">

            <p className='text-white'>If you or a founder you know has a revolutionary startup idea to help the world build future ,then Lacuna Venture Workshop Session wants to make it happen.</p>
            </div>
            <Link to='/membership'>

            <button>Register Now</button>
            </Link>
            <h4>and <span>Get 50% off</span> on your first registration</h4>

        </Container>
  )
}

export default OfferCard
const Container = styled.div` 
margin-bottom:50px ;
button{
    transition:.5s ;
    margin:15px ;
    background-color:#fa7525 ;
    padding:5px ;
    border-radius:3px ;
    font-weight:bold ;
    color:white ;
    border:none ;
    &:hover{
        transform:scale(1.1) ;
        background-color: black;
    }
}
.text-container{

    width:70% ;
    margin:auto ;
    background:#fa7525 ;
    border-radius:15px ;    
    box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;  
    color:white ;
}
span{
    color:#fa7525 ;
    font-weight:bold ;
}
`
